module.exports = __webpack_public_path__ + "img/cardin_logo.0dbdd932.jpg";